import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";
import { customStyles } from "./DropDownStyles";

export default class DataFieldDropDown extends React.Component {
  state = {
    options: []
  };

  fetchData = search => {
    const { company_id, data_field_name } = this.props;
    return fetchJson("/products/api/client_lists/items", {
      company_id,
      data_field_name_id: data_field_name.id,
      search
    }).then(records => {
      var options = records.map(m => ({ label: m.name, value: m.id }));
      this.setState({ options });
      return options;
    });
  };

  render() {
    const { onChange, multiple, values } = this.props;
    const { options } = this.state;
    return (
      <AsyncSelect
        value={values}
        placeholder={"Select"}
        isMulti
        styles={customStyles()}
        id="suite_id"
        cacheOptions
        defaultOptions
        loadOptions={this.fetchData}
        onChange={onChange}
        isClearable={true}
      />
    );
  }
}
